// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__1pKet","navItem":"styles_navItem__2iQAO","navTitle":"styles_navTitle__3teeo","activeTabItem":"styles_activeTabItem__26UKW"};